import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import type {ICreateFinancialApplicationRequest} from "../types/financial_application";
import {getCbkAccountHeaders} from "../utils/get_cbk_account_headers";

const financialApplicationEndpoints = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        createFinancialApplication: builder.mutation<unknown, ICreateFinancialApplicationRequest>({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                try {
                    const payload = await appendTurnstileToken(body, TurnstileAction.FINANCIAL_APPLICATION);
                    const result = await baseQuery({
                        url: apiPath.applications.financialApplication.create,
                        method: "POST",
                        body: payload,
                        headers: getCbkAccountHeaders(body.source)
                    });

                    if (result.error) {
                        return {error: result.error};
                    }

                    return {data: result.data};
                } catch (_error) {
                    return {error: createTurnstileRtkError()};
                }
            }
        })
    })
});

export const {useCreateFinancialApplicationMutation} = financialApplicationEndpoints;
import {apiPath} from "@pg-mono/rp-api-routes";
import {createTurnstileRtkError} from "@pg-mono/turnstile";

import {rpApi} from "../../app/api/rp_api";
import {TurnstileAction} from "../../app/constants/turnstile_actions";
import {appendTurnstileToken} from "../../app/turnstile";
import type {ICreateFinancialApplicationRequest} from "../types/financial_application";
import {getCbkAccountHeaders} from "../utils/get_cbk_account_headers";

const financialApplicationEndpoints = rpApi.injectEndpoints({
    endpoints: (builder) => ({
        createFinancialApplication: builder.mutation<unknown, ICreateFinancialApplicationRequest>({
            queryFn: async (body, _api, _extraOptions, baseQuery) => {
                try {
                    const payload = await appendTurnstileToken(body, TurnstileAction.FINANCIAL_APPLICATION);
                    const result = await baseQuery({
                        url: apiPath.applications.financialApplication.create,
                        method: "POST",
                        body: payload,
                        headers: getCbkAccountHeaders(body.source)
                    });

                    if (result.error) {
                        return {error: result.error};
                    }

                    return {data: result.data};
                } catch (_error) {
                    return {error: createTurnstileRtkError()};
                }
            }
        })
    })
});

export const {useCreateFinancialApplicationMutation} = financialApplicationEndpoints;
